import { useTheme } from '@material-ui/core';
import DialogDataMLStyled from './DialogDataMLStyled';
import { useIntl } from 'umi';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// 关闭modal图标
// import SvgIconML from '@/components/SvgIconML/SvgIconML';

const DialogDataML = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const theme = useTheme();
  return (
    <DialogDataMLStyled
      theme={theme}
      // style={modalStyle}
      // className={classes.paper}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      open={props.open}
      onClose={props.onClose}
      button={props?.button}
      params={props?.initParams}
    >
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.content}
        </DialogContentText>
      </DialogContent>
      {props?.button ? (
        props?.button?.isShow && (
          <DialogActions>{props.button.buttonNode}</DialogActions>
        )
      ) : (
        <DialogActions>
          <Button
            onClick={(e) => (props?.handleClose ? props?.handleClose(e) : null)}
            color="primary"
          >
            {formatMessage({ id: 'comm.action.btn.08' })}
          </Button>
          <Button onClick={props?.handleConfirm} autoFocus color="primary">
            确定
          </Button>
        </DialogActions>
      )}
    </DialogDataMLStyled>
  );
};
export default DialogDataML;
